import styled from 'styled-components';
import BorderLeftTh from '../BorderLeftTh';

const BorderTopBottomTh = styled(BorderLeftTh)`
  border-left: 0;
  border-right: 0;
`;

export default BorderTopBottomTh;
